<template>
  <svg
    height="40"
    width="40"
    style="fill: none"
    viewBox="0 0 361.16 329.33"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style="fill: #21409a"
      d="M281.33,221.84v45.13c0,12.35-10.01,22.36-22.36,22.36H62.36c-12.35,0-22.36-10.01-22.36-22.36V62.36c0-12.35,10.01-22.36,22.36-22.36h151.66c7.83,0,14.17-6.35,14.17-14.17v-11.65c0-7.83-6.35-14.17-14.17-14.17H62.36C27.92,0,0,27.92,0,62.36v204.61c0,34.44,27.92,62.36,62.36,62.36h196.61c34.44,0,62.36-27.92,62.36-62.36v-45.13c0-7.83-6.35-14.17-14.17-14.17h-11.65c-7.83,0-14.17,6.35-14.17,14.17Z"
    />
    <path
      style="fill: #21409a"
      d="M184.02,244.03h-44.26L327.02,56.78c7.81-7.81,20.47-7.81,28.29,0h0c7.81,7.81,7.81,20.47,0,28.29l-150.26,150.26c-5.58,5.58-13.14,8.71-21.02,8.71Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
